import { addMonetaryValues, BookingFeeMode, configurationSettings, isBookingFeeApplicableToOrder, multiplyMonetaryValue } from '@vista/omnichannel-components-domain';
export const getFormattedTicketPrice = (ticket, i18n, quantity) => {
    const { bookingFeeMode } = configurationSettings.data.order;
    const price = isBookingFeeApplicableToOrder() && bookingFeeMode === BookingFeeMode.Inclusive && ticket.bookingFee
        ? addMonetaryValues(ticket.price, ticket.bookingFee.amount)
        : ticket.price;
    return i18n.monetaryValue(multiplyMonetaryValue(price, quantity !== null && quantity !== void 0 ? quantity : 1));
};
